import { 
    BOOKINGS_FETCHING,
    BOOKINGS_FAILED,
    BOOKINGS_SUCCESS 
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case BOOKINGS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case BOOKINGS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case BOOKINGS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
};
